import React from 'react';
import { Card, Typography } from 'antd';
import Markdown from 'markdown-to-jsx';
import './ChatMessage.scss';

const { Text } = Typography;

interface ChatMessageProps {
  text: string;
  sender: 'user' | 'bot';
}

const ChatMessage = (props: ChatMessageProps) => {
  return (
    <div className={`ChatWrapper ${props.sender === 'user' ? 'user' : 'bot'}`}>
      <Card className="ChatWrapper__Bubble">
        <div className="ChatWrapper__Bubble__Content">
          {props.text && props.sender === 'bot' ? (
            <div className="ChatWrapper__Bubble__Content__Text">
              <Markdown options={{ disableParsingRawHTML: true }}>{props.text}</Markdown>
            </div>
          ) : (
            props.text && <Text className="ChatWrapper__Bubble__Content__Text">{props.text}</Text>
          )}
        </div>
      </Card>
    </div>
  );
};

export default ChatMessage;
